import styled from 'styled-components';
import { TextLink } from '@spotify-internal/encore-web';
import theme from 'lib/theme';
import * as tokens from 'styles';

export const linkColor = theme({
  duoLight: tokens.royalBlue,
  duoDark: tokens.white,
  duoLegacyDark: tokens.white,
  familyLight: tokens.royalBlue,
  familyDark: tokens.black,
});

const UnderlinedLink = styled(TextLink)`
  color: ${linkColor};
  text-decoration: underline;

  &[href]:hover:not([disabled]) {
    color: ${linkColor};
  }
`;

export default UnderlinedLink;
